import React, { useContext } from 'react'
import {
  Divider,
  useMediaQuery,
  InputAdornment,
  IconButton,
  TextField,
  MenuItem,
  Select,
  Grid,
} from '@material-ui/core'
import FlexView from 'react-flexview/lib'
import {
  FirebaseService,
  FirebaseConfigKey,
} from '../../services/FirebaseService'
import EventIcon from '@material-ui/icons/Event'
import { useForm, Controller } from 'react-hook-form'
import { ClaimContextStore, ACTIONS } from '../../context/ClaimContext'
import {
  EventEmitterService,
  EventKey,
} from '../../services/EventEmitterService'
import { ClaimType } from '../../models/claim/ClaimType'
import LocationOnIcon from '@material-ui/icons/LocationOn'
import AccountBalanceWalletIcon from '@material-ui/icons/AccountBalanceWallet'
import './ClaimEnter.scss'
import HelpIcon from '@material-ui/icons/Help'
import { ClaimReason } from '../../models/claim/ClaimReason'
import { BackButton } from '../Core/Buttons/BackButton'
import { ContinueButton } from '../Core/Buttons/ContinueButton'
import { Action } from '../../models/Action'

export const ClaimIncidentInfo = () => {
  const claimContext = useContext(ClaimContextStore)
  const isMobileByWidth = !useMediaQuery((theme) => theme.breakpoints.up('md'))
  const { register, getValues, trigger, control, errors, watch, setValue } =
    useForm({
      defaultValues: claimContext.claim_incident_info,
      mode: 'onChange',
    })
  const claimTypeWatch = watch(
    'claim_type',
    claimContext.claim_incident_info.claim_type
  )
  const claimReasonWatch = watch(
    'claim_reason',
    claimContext.claim_incident_info.claim_reason
  )

  const onContinue = async () => {
    let valid = await trigger()

    if (!valid) return

    claimContext.dispatch(new Action(ACTIONS.SET_INCIDENT_INFO, getValues()))

    if (getValues().claim_type == ClaimType.LIABILITY)
      EventEmitterService.dispatch(EventKey.CLAIM_HULL_INFO_FINISHED)
    else EventEmitterService.dispatch(EventKey.CLAIM_INCIDENT_INFO_FINISHED)
  }

  const hasHull = () =>
    claimContext.selected_policy &&
    (claimContext.selected_policy.insuredDrones.length > 0 ||
      claimContext.selected_policy.insuredEquipment.length > 0)

  React.useEffect(() => {
    if (
      claimTypeWatch == ClaimType.LIABILITY &&
      (claimReasonWatch == ClaimReason.LOSS ||
        claimReasonWatch == ClaimReason.THEFT)
    ) {
      setValue('claim_reason', ClaimReason.OTHER)
    }
  }, [claimTypeWatch, claimReasonWatch])

  return (
    <>
      <br />
      <div className="text-title blue bold">Incident Info</div>
      {!isMobileByWidth && <Divider />}
      <div className="text-body gray margin-top-6">
        Please insert the incident details
      </div>
      <Grid container spacing={3} className="margin-top-basic">
        <Grid item xs={12} sm={12} md={6}>
          <TextField
            fullWidth
            variant="outlined"
            label="Location"
            placeholder="Where did the incident take place?"
            name="location"
            inputRef={register({ required: true })}
            helperText={errors.location && 'Location is required'}
            error={!!errors.location}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <LocationOnIcon className="lightgrayblue" />
                </InputAdornment>
              ),
            }}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <Controller
            control={control}
            rules={{
              validate: (x) => !!x && x != 'none',
              required: true,
            }}
            name="claim_type"
            defaultValue="none"
            as={
              <Select
                id="height"
                fullWidth
                error={!!errors.claim_type}
                variant="outlined">
                <MenuItem disabled value={'none'}>
                  <FlexView vAlignContent={'center'}>
                    <AccountBalanceWalletIcon className="lightgrayblue" />
                    <div className="placeholder-text margin-left-6">
                      Claim Type
                    </div>
                  </FlexView>
                </MenuItem>
                <MenuItem disabled={!hasHull()} value={ClaimType.HULL}>
                  <FlexView vAlignContent={'center'}>
                    <AccountBalanceWalletIcon className="lightgrayblue" />
                    <div className="margin-left-6">{ClaimType.HULL}</div>
                  </FlexView>
                </MenuItem>
                <MenuItem value={ClaimType.LIABILITY}>
                  <FlexView vAlignContent={'center'}>
                    <AccountBalanceWalletIcon className="lightgrayblue" />
                    <div className="margin-left-6">{ClaimType.LIABILITY}</div>
                  </FlexView>
                </MenuItem>
                <MenuItem
                  disabled={!hasHull()}
                  value={ClaimType.HULL_AND_LIABILITY}>
                  <FlexView vAlignContent={'center'}>
                    <AccountBalanceWalletIcon className="lightgrayblue" />
                    <div className="margin-left-6">
                      {ClaimType.HULL_AND_LIABILITY}
                    </div>
                  </FlexView>
                </MenuItem>
              </Select>
            }
          />
        </Grid>
        <Grid item xs sm={12} md={6}>
          <Controller
            control={control}
            rules={{
              validate: (x) => !!x && x != 'none',
              required: true,
            }}
            name="claim_reason"
            defaultValue="none"
            as={
              <Select
                id="height"
                fullWidth
                error={!!errors.claim_reason}
                variant="outlined">
                <MenuItem disabled value={'none'}>
                  <FlexView vAlignContent={'center'}>
                    <HelpIcon className="lightgrayblue" />
                    <div className="placeholder-text margin-left-6">
                      Cause of Incident
                    </div>
                  </FlexView>
                </MenuItem>
                <MenuItem value={ClaimReason.CRASH}>
                  <FlexView vAlignContent={'center'}>
                    <HelpIcon className="lightgrayblue" />
                    <div className="margin-left-6">{ClaimReason.CRASH}</div>
                  </FlexView>
                </MenuItem>
                <MenuItem
                  disabled={claimTypeWatch == ClaimType.LIABILITY}
                  value={ClaimReason.LOSS}>
                  <FlexView vAlignContent={'center'}>
                    <HelpIcon className="lightgrayblue" />
                    <div className="margin-left-6">{ClaimReason.LOSS}</div>
                  </FlexView>
                </MenuItem>
                <MenuItem
                  disabled={claimTypeWatch == ClaimType.LIABILITY}
                  value={ClaimReason.THEFT}>
                  <FlexView vAlignContent={'center'}>
                    <HelpIcon className="lightgrayblue" />
                    <div className="margin-left-6">{ClaimReason.THEFT}</div>
                  </FlexView>
                </MenuItem>
                <MenuItem value={ClaimReason.OTHER}>
                  <FlexView vAlignContent={'center'}>
                    <HelpIcon className="lightgrayblue" />
                    <div className="margin-left-6">{ClaimReason.OTHER}</div>
                  </FlexView>
                </MenuItem>
              </Select>
            }
          />
        </Grid>
      </Grid>
      <br />
      <FlexView className="margin-top-basic">
        <BackButton />
        <ContinueButton onClick={onContinue} />
      </FlexView>
    </>
  )
}
